import AppManager from './AppManager';

(async (sentry) => {
    try {
        const widget = new AppManager();
        await widget.init();
    } catch (error) {
        debugger;
        console.error('🚩🚩 FCBP - CRITICAL ERROR! 🚩🚩');
        console.error(error);
        sentry.captureException(error);
    }
})(window.__PRIME_AI_ENVIRONMENT__.SENTRY);
